import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNServiceCode } from './cnservicecode';
import { CNServiceCodeCustom } from './cnservicecodecustom';
import { CNServiceCodeINAMI } from './cnservicecodeinami';
import { SNItem } from './snitem';

@RegisterItem()
export class CNContactType extends SNItem {

    private serviceCodes: CNServiceCode[];

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNContactType';
    }

    get name(): string {
        return this.getProperty('name');
    }

    get codes(): CNServiceCode[] {
        if (!this.serviceCodes) {
            return undefined;
        }
        return this.serviceCodes;
    }

    public clone(): any {
        return new CNContactType();
    }

    /**
     * JSON
     */

     public fromJson(json: any, emitLoaded?: boolean): void {
        super.fromJson(json, emitLoaded);
        if (typeof json.codes !== 'undefined' && Array.isArray(json.codes) && json.codes.length !== 0) {
            // codes
            this.serviceCodes = [];
            json.codes.forEach(aCode => {
                if (aCode.Key === 'SNItem.CNItem.CNServiceCode.CNServiceCodeINAMI') {
                    const acode = new CNServiceCodeINAMI();
                    acode.fromJson(aCode);
                    this.serviceCodes.push(acode);
                }
                if (aCode.Key === 'SNItem.CNItem.CNServiceCode.CNServiceCodeCustom') {
                    const acode = new CNServiceCodeCustom();
                    acode.fromJson(aCode);
                    this.serviceCodes.push(acode);
                }
            });
        }
    }
}
